export default function gaEvent(action, payload) {
  window.gtag(
    'event',
    `${action}${
      process.env.NEXT_PUBLIC_PADDLE_VENDOR_TEXT_TEST === 'prd' ? '' : '_dev'
    }`,
    payload,
  );
}
